import React, { useState } from 'react'
import styles from './PagoLinkExitoso.module.css'
import checkverde from '../../img/pacifico-logo-white.png'

const PagoLinkExitoso = ({valores, monto, tipoMon, accion, estado}) => {

    const [mostrarModal, setModal] = useState(false)

    const mostrarPopup = () => {
        setModal(!mostrarModal) 
    }

    function myFunction() {
        accion()
        if (estado !== '')
            mostrarPopup()
    }

    return (
        <div>
            <div className={styles.SegundoCard} style={{
                display: 'flex', flexDirection: 'column',
                alignItems: 'center'
            }}>

                <div className={styles.titulo}>
                    <h1>¡Gracias!</h1>
                </div>
                <div className={styles.parrafo}>
                    <p>Tu compra será procesada cuando hayas realizado el pago a través del link enviado al correo electrónico registrado.</p>
                </div>
                <div className={styles.contenido}>
                    <div className={styles.imagenContenedor}>
                        <div className={styles.imagen}><img src={checkverde} alt='xx' /></div>
                    </div>
                    <div style={{
                        display: 'flex', flexDirection: 'column',
                        justifyContent: 'center',
                        width: '100%', height: '80vh'
                    }}>
                        <div className={styles.flexCajas}>
                            <div className={styles.caja2}>
                                <div className={styles.datos}>
                                    <div className={styles.texto1}>
                                        <label className={styles.encabezado}>Correo electrónico</label> 
                                        <label className={styles.parametro}>{valores.contacto.email}</label>
                                    </div>
                                </div>
                                <div className={styles.datos}>
                                    <div className={styles.texto2}>
                                        <label className={styles.encabezado}>Celular</label> 
                                        <label className={styles.parametro}>{valores.contacto.celular}</label>
                                    </div>
                                </div>
                                <div className={styles.datos}>
                                    <div className={styles.texto3}>
                                        <label className={styles.encabezado}>Nombres</label> 
                                        <label className={styles.parametro}>
                                            {valores.nombres.charAt(0) + valores.nombres.slice(1).toLowerCase()}
                                        </label>
                                    </div>
                                </div>
                                <div className={styles.datos}>
                                    <div className={styles.texto4}>
                                        <label className={styles.encabezado}>Apellidos</label> 
                                        <label className={styles.parametro}>
                                            {valores.apellidoPaterno.charAt(0) + valores.apellidoPaterno.slice(1).toLowerCase() + ' ' + 
                                            valores.apellidoMaterno.charAt(0) + valores.apellidoMaterno.slice(1).toLowerCase()}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.caja3}>
                                <div className={styles.datos2}>
                                    <div className={styles.texto5}><label className={styles.encabezado}>Número documento</label > <label className={styles.parametro}>{valores.numeroDocumento}</label></div></div>
                                <div className={styles.datos2}>
                                    <div className={styles.texto6}><label className={styles.encabezado}>Monto</label> <label className={styles.parametro}>{tipoMon} {monto}</label></div></div>
                                <div className={styles.datos2}>
                                    <div className={styles.texto7}><label className={styles.encabezado}></label> <label></label></div></div>
                                <div className={styles.datos2}>
                                    <div className={styles.texto8}><label className={styles.encabezado}></label> <label></label></div></div>
                                {estado ? '' :
                                    <div className={styles.datos2}>
                                        <div className={styles.texto9}>
                                            <button
                                                className={styles['btnValidar']}
                                                onClick={() => myFunction()}
                                            >
                                                Validar Pago
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {estado ?
                    <div className={styles['confirmacion']}>
                        <div className={styles['round']}>
                            <input type="checkbox" id="checkbox" defaultChecked={true} />
                            <label htmlFor="checkbox"></label>
                        </div>
                        <label className={styles['label-confirmacion']}>Pago completado.</label>
                    </div>
                : estado === false ?
                    <div className={styles['confirmacion']}>
                        <div className={styles['round2']}>
                            <input type="checkbox" id="checkbox" defaultChecked={true} disabled={true} />
                            <label htmlFor="checkbox"></label>
                        </div>
                        <label className={styles['label-confirmacion2']}>Pago pendiente de realizar.</label>
                    </div>
                : ''}
            </div>
        </div>
    )
}

export default PagoLinkExitoso